module.exports = __webpack_public_path__ + "img/imac.0104d3bb.png";